export default "__VITE_ASSET__JovL2mSY__"